import Link from "next/link";
import { CSSProperties } from "react";
import getcdn from "~/modules/get_cdn_link";
import Img from "./Image";

const IosButton: React.FC<{ style?: CSSProperties }> = ({ style }) => (
  <Link href='https://a.infina.link/A3yP/downloadios'>
    <a target='_blank' style={{ height: 'fit-content', ...style }} rel="noreferrer">
      <Img
        src={getcdn('images/home/ios_button.png?ver=1')}
        alt="download app store"
        width={125}
        height={40}
        layout="fixed"
      />
    </a>
  </Link>
)

export default IosButton
